import React, { Fragment } from "react";
import { Helmet } from "react-helmet";

const ThankYou = () => {
  
  return (
    <Fragment>
      <Helmet>
        {/* TITLE */}
    <title>
      Thank You | Your Service Request Has Been Received - Helper Ji
    </title>

    {/* DESCRIPTION */}
    <meta
      name="description"
      content="Thank you for contacting HelperJi. Your request has been successfully submitted, & our team will review the details & get in touch with you shortly to assist you."
    />

    {/* KEYWORDS */}
    <meta
      name="keywords"
      content="Thank You Page, Request Submitted Successfully, Service Enquiry Confirmation, Contact Form Submission, Booking Confirmation Page, Enquiry Received, Service Request Acknowledgement, Customer Confirmation Page, Thank You For Contacting Us, Helper Ji, Cleaning Services"
    />

    {/* ROBOTS */}
    <meta name="robots" content="index, follow" />
    <meta name="googlebot" content="index, follow" />
    <meta name="bingbot" content="index, follow" />
    <meta name="revisit-after" content="daily" />
    <meta name="copyright" content="Helper Ji" />

    {/* CANONICAL */}
    <link rel="canonical" href="https://www.helperji.in/thank-you" />

    {/* OPEN GRAPH */}
    <meta
      property="og:title"
      content="Thank You | Your Service Request Has Been Received - Helper Ji"
    />
    <meta
      property="og:description"
      content="Thank you for contacting HelperJi. Your request has been successfully submitted, & our team will review the details & get in touch with you shortly to assist you."
    />
    <meta
      property="og:image"
      content="https://www.helperji.in/assets/img/aboutbanner1.jpg"
    />
    <meta property="og:site_name" content="Helper Ji" />
    <meta property="og:type" content="website" />
    <meta
      property="og:url"
      content="https://www.helperji.in/thank-you"
    />

    {/* TWITTER */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@helperji_" />
    <meta name="twitter:creator" content="@helperji_" />
    <meta
      name="twitter:title"
      content="Thank You | Your Service Request Has Been Received - Helper Ji"
    />
    <meta
      name="twitter:description"
      content="Thank you for contacting HelperJi. Your request has been successfully submitted, & our team will review the details & get in touch with you shortly to assist you."
    />
    <meta
      name="twitter:image"
      content="https://www.helperji.in/assets/img/aboutbanner1.jpg"
    />

    {/* WEBPAGE SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Thank You",
        "url": "https://www.helperji.in/thank-you",
        "description": "Thank you for contacting HelperJi. Your request has been successfully submitted and our team will contact you shortly."
      }
      `}
    </script>
      <script type="text/javascript">
    {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
  </script>
      </Helmet>
    <section className="thank-you text-center" style={{ padding: "80px 20px" }}>
      <h1>Thank You!</h1>
      <p>
        Your message has been sent successfully.  
        Our team will contact you shortly.
      </p>
    </section>
    </Fragment>
  );
};

export default ThankYou;
